import ServerCookie from 'cookie';
import BrowserCookie from 'js-cookie';
/**
 * Isomorphic function that takes a cookie key and returns a string value or undefined.
 * If a server-side context is provided, the function will read cookies from the given context.
 * Context can be a NextJS context containing the request's parsed cookies, a basic context object
 * containing the request and its headers, or a string representing the cookie header.
 * @param {string}               name          cookie name
 * @param {Object | string }     serverContext server context
 * @returns {string | undefined}               cookie value
 */
export var getCookie = function getCookie(name, serverContext) {
  if (serverContext) {
    var _serverContext$req$he;
    // server-side cookie handling
    var cookies = typeof serverContext === 'string' // cookie header string
    ? ServerCookie.parse(serverContext) : serverContext.req.cookies // NextJS pre-parsed cookies
    ? serverContext.req.cookies : ServerCookie.parse((_serverContext$req$he = serverContext.req.headers.cookie) !== null && _serverContext$req$he !== void 0 ? _serverContext$req$he : ''); // http request cookie header
    return cookies[name];
  } else {
    // client-side cookie handling
    return BrowserCookie.get(name);
  }
};
export default getCookie;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/cookies/getCookie.js
// module id = 131
// module chunks = 11